<template>
  <div class="price-list-container">
    <div v-if="priceList.length === 0" class="empty-state">
      暂无电价信息
    </div>
    <div v-else class="price-table">
      <div class="price-table-header">
        <div class="header-cell">时段名称</div>
        <div class="header-cell">电价(元/kWh)</div>
      </div>
      <div class="price-table-body">
        <div v-for="item in priceList" :key="item.name" class="price-table-row">
          <div class="price-period">
            <span class="period-dot" :style="{ backgroundColor: item.color }"></span>
            <span class="period-name">{{ item.label }}</span>
          </div>
          <div class="price-value">{{ formatPrice(item.price) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({ priceDetails: [] })
  }
})

// 时段配置
const periodConfig = {
  sharp: { label: '尖峰时段', color: '#FF6B6B', order: 0 },
  peak: { label: '高峰时段', color: '#FF7A45', order: 1 },
  flat: { label: '平时段', color: '#10B981', order: 2 },
  valley: { label: '谷时段', color: '#3A68FF', order: 3 },
  deepValley: { label: '深谷时段', color: '#FFD700', order: 4 }
}

// 格式化价格，保留5位小数
const formatPrice = (price) => {
  return Number(price || 0).toFixed(5)
}

// 处理价格列表
const priceList = computed(() => {
  const priceDetails = props.data?.priceDetails || []

  return priceDetails
    .filter(item => periodConfig[item.name])
    .map(item => ({
      name: item.name,
      label: periodConfig[item.name].label,
      color: periodConfig[item.name].color,
      price: Number(item.price) || 0,
      order: periodConfig[item.name].order
    }))
    .sort((a, b) => a.order - b.order)
})
</script>

<style scoped lang="scss">
.price-list-container {
  width: 100%;
  height: 100%;
  padding: 5px 20px 20px 20px;
  display: flex;
}

.empty-state {
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(46, 46, 46, 0.5);
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
}

.price-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.price-table-header {
  display: flex;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(106, 114, 124, 0.1);
  margin-bottom: 12px;
  justify-content: center;
  gap: 40px;
}

.header-cell {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: rgba(46, 46, 46, 0.70);
  text-align: center;
  min-width: 120px;

  &:first-child {
    min-width: 150px;
  }
}

.price-table-body {
  display: flex;
  flex-direction: column;
  gap: 52px;
}

.price-table-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
}

.price-period {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 150px;
  justify-content: center;
}

.period-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.period-name {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(46, 46, 46, 1);
}

.price-value {
  text-align: center;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(46, 46, 46, 1);
  min-width: 120px;
}
</style>
